import styled from 'styled-components'

import { PriceWrapper } from '@/components/Price/Price.styles'

export const TicketTypeCardHeader = styled.div`
  flex: 1 1 auto;
  padding-right: 1rem;

  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 0rem;
  }

  p {
    margin-bottom: 0;
    font-size: 0.9rem;
    color: ${props => props.theme.color.muted};
  }
`

export const TicketTypeCardPrice = styled.div`
  text-align: right;
  margin-right: 1.25rem;

  ${PriceWrapper} {
    font-size: 1.3rem;
    font-weight: 600;
  }
`

export const TicketTypeCardQty = styled.div``

export const TicketTypeCardWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 6rem;
  background-color: ${props => props.theme.color.body};
  padding: 1.5rem;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`
